import { render } from "./404.vue?vue&type=template&id=2b54cb7a&scoped=true"
import script from "./404.vue?vue&type=script&lang=ts"
export * from "./404.vue?vue&type=script&lang=ts"

import "./404.vue?vue&type=style&index=0&id=2b54cb7a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2b54cb7a"

export default script